import { ButtonHTMLAttributes } from 'react';
import { cm } from 'src/utils/classNames';
import { WithRef } from 'src/utils/UtilityTypes';

type Props = WithRef<
	ButtonHTMLAttributes<HTMLButtonElement>,
	HTMLButtonElement
>;

export default function FooterButton({ className, ...rest }: Props) {
	return (
		<button
			className={cm(
				'flex items-center gap-x-xs',
				'rounded-xs px-xs py-2xs typo-body-xs text-text-secondary',
				'hover:bg-button-secondary-bg hover:text-text-default',
				className
			)}
			{...rest}
		/>
	);
}
